import { activeCart } from "@/services/global";
import { setCookie } from "cookies-next";
import jwt from "jsonwebtoken";

export function findObjectById(data, targetId) {
  for (const item of data) {
    if (item?.id == targetId) {
      // Found the target object
      return item;
    }

    if (item?.children_data && item?.children_data.length > 0) {
      // Recursively search in the nested children_data
      const result = findObjectById(item?.children_data, targetId);
      if (result) {
        return result;
      }
    }
  }

  // Target object not found
  return null;
}

export function findObjectByIdV2(data, targetKey, searchValue) {
  if (data?.length) {
    for (const item of data) {
      if (
        item[targetKey]?.split("-c-")?.[1] == searchValue?.split("-c-")?.[1]
      ) {
        // prettyConole(searchValue, item)
        return item;
      }

      if (item?.children_data && item?.children_data?.length > 0) {
        const result = findObjectByIdV2(
          item?.children_data,
          targetKey,
          searchValue
        );
        if (result) {
          // prettyConole(searchValue, result)
          return result;
        }
      }
    }
  }
  // Target object not found
  return null;
}

export function unescapeHtml(escapedHtml) {
  const htmlEntities = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'",
  };

  return escapedHtml?.replace(
    /&amp;|&lt;|&gt;|&quot;|&#39;/g,
    (match) => htmlEntities[match]
  );
}

export const preventLettersInInput = (event) => {
  const input = event.key;
  // Allow control keys (e.g., backspace, delete)
  if (
    event.ctrlKey ||
    event.altKey ||
    event.metaKey ||
    input === "Backspace" ||
    input === "Delete"
  ) {
    return;
  }

  // Check if the input is not a number
  if (isNaN(Number(input))) {
    event.preventDefault();
  }
};

export function camelCaseToCapitalized(name) {
  const words = name.split(/(?=[A-Z])/);
  const capitalizedWords = words.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1)
  );
  const capitalizedString = capitalizedWords.join(" ");
  return capitalizedString;
}

export function isTokenExpired(token) {
  const decodedToken = jwt.decode(token);
  if (!decodedToken || !decodedToken.exp) {
    // Invalid token or missing expiration time
    return true;
  }

  // Convert expiration time to milliseconds
  const expirationTimeMs = decodedToken.exp * 1000;
  // Get current time in milliseconds
  const currentTimeMs = Date.now();

  // Check if the token is expired
  return currentTimeMs >= expirationTimeMs;
}

export function tokenDecoder(token) {
  return jwt.decode(token);
}

export function decodeJwt(token, fromServer = true) {
  if (!token) {
    return;
  }
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  if (!fromServer) {
    return JSON.parse(window.atob(base64));
  } else {
    return JSON.parse(Buffer.from(base64, "base64").toString());
  }
}

export function utcToLocal(dateTimeString) {
  // Parse the input UTC date-time string
  const utcDate = new Date(dateTimeString.replace(" ", "T") + "Z");

  // Extract the components of the local date-time
  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, "0");
  const day = String(utcDate.getDate()).padStart(2, "0");
  const hours = String(utcDate.getHours()).padStart(2, "0");
  const minutes = String(utcDate.getMinutes()).padStart(2, "0");
  const seconds = String(utcDate.getSeconds()).padStart(2, "0");

  // Format the local date-time string
  const localDateTimeString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

  return localDateTimeString;
}

export function compareObjects(obj1, obj2) {
  // Check if both arguments are objects
  if (
    typeof obj1 !== "object" ||
    obj1 === null ||
    typeof obj2 !== "object" ||
    obj2 === null
  ) {
    return obj1 === obj2;
  }

  // Get keys of both objects
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of keys is different
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if values of all keys are equal
  for (let key of keys1) {
    if (!keys2.includes(key) || !compareObjects(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}

export function extractOptionIds(obj) {
  const result = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key].hasOwnProperty("option_id")) {
      result[key] = obj[key].option_id;
    }
  }

  return result;
}

export const countDownHandler = (toDate) => {
  const difference = new Date(toDate) - new Date();
  let timeLeft = { isCountDown: false };

 if (difference > 0) {
    timeLeft = {
      isCountDown: true,
      weeks: Math.floor(difference / (1000 * 60 * 60 * 24 * 7)),
      days: Math.floor((difference / (1000 * 60 * 60 * 24)) % 7),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }
  return timeLeft;
};

//  check search language
export const checkSearchLang = (word, locale) => {
  const englishRegex = /^[a-zA-Z]+$/;
  const arabicRegex = /^[\u0600-\u06FF]+$/;

  if (englishRegex.test(word)) {
    return "en";
  } else if (arabicRegex.test(word)) {
    return "ar";
  }
  return locale;
};

export const handleStartWithSlashInUrl = (url) =>
  url?.startsWith("/") ? url?.slice(1) : url;

export const validateImgSrc = (src) => {
  const isProd = process.env.NEXT_PUBLIC_NODE_ENV === "production";
  const newBaseUrl = process.env.NEXT_PUBLIC_IMG_BASEURL;
  const baseUrl = isProd
    ? "https://store.awahed.com/media"
    : "https://aw2.v4tech.com/media";
  const finalSrc = src?.startsWith(baseUrl)
    ? src?.replace(baseUrl, newBaseUrl)
    : src;
  return finalSrc?.replace("/media//", "/media/");
};

export const handleAddToActiveCart = async (handshake, order_id, push) => {
  const res = await activeCart(handshake, order_id);

  const cart_id = res?.data?.data?.cart_id;

  if (cart_id) {
    setCookie("quote", cart_id);
    setTimeout(() => {
      push("/cart");
    }, 200);
  }
};
